<key-pie-graph *ngIf="data"
    [datasets]="data.datasets"
    [fill]="data.fill"
    [labels]="data.labels"
    [legend]="data.legend"
    [showLabelsOnGraph]="data.showLabelsOnGraph"
    (onPointSelection)="onMeasureSelection.emit(data.datasets[$event.datasetIndex].id)"></key-pie-graph>